import { MainRequest } from "./service";
import axios from "axios";
import qs from "qs";
import Config from "../config";
import Storage from "../utils/Storage";

// 登录方式
export enum LoginType {
    CAS = "1",
    Form = "0"
}

function keepLoginInfo(data: {
    teacherNo: string;
    teacherName: string;
    token: string;
    loginType: LoginType;
}) {
    Storage.set("teacherNo", data.teacherNo);
    Storage.set("teacherName", data.teacherName);
    Storage.set("token", data.token);
    Storage.set("LoginType", data.loginType);
}

interface LoginData {
    token: string;
    name: string;
    no: string;
    loginType: LoginType;
}

/**
 * 教师普通登录
 */
export async function login(username: string, password: string) {
    const res = await MainRequest.post<SuccessData<LoginData>>(
        "/teacher/teacherLogin",
        new URLSearchParams({
            loginName: username?.trim(),
            pwd: password?.trim(),
            customerCode: Config.CustomCode
        })
    );

    const { name: teacherName, no: teacherNo, ...data } = res.data.data;
    keepLoginInfo({ teacherName, teacherNo, ...data });
}

/**
 * 教师普通强制登录
 */
export async function loginRedict(username: string, password: string) {
    const res = await MainRequest.post<SuccessData<LoginData>>(
        "/teacher/teacherLoginN",
        new URLSearchParams({
            loginName: username?.trim(),
            pwd: password?.trim(),
            customerCode: Config.CustomCode
        })
    );

    const { name: teacherName, no: teacherNo, ...data } = res.data.data;
    keepLoginInfo({ teacherName, teacherNo, ...data });
}

/**
 * 教师动态码登录
 */
export async function dynamicLogin(username: string, password: string) {
    const res = await MainRequest.post<SuccessData<LoginData>>(
        "/teacher/dynamicLogin",
        new URLSearchParams({
            loginName: username?.trim(),
            pwd: password?.trim(),
            customerCode: Config.CustomCode
        })
    );

    const { name: teacherName, no: teacherNo, ...data } = res.data.data;
    keepLoginInfo({ teacherName, teacherNo, ...data });
}

/**
 * 教师单点登录
 */
export function authLogin(code: string) {
    return axios
        .post<SuccessData<LoginData>>(
            "teacher/authLogin",
            qs.stringify({ code })
        )
        .then(res => {
            const { name: teacherName, no: teacherNo, ...data } = res.data.data;
            keepLoginInfo({ teacherName, teacherNo, ...data });
        });
}

interface LoginMethod {
    unifyAuthLogin: BooleanValue; //是否统一认证方式登录（0否1是）
    normalAuthLogin: BooleanValue; //是否普通登录（0否1是）
    dynamicCertLogin: BooleanValue; //是否动态凭证登录（0否1是）
}

/**
 * 获取可登录类型
 */
export function getLoginSet() {
    return axios
        .get<SuccessData<LoginMethod>>(`/teacher/getLoginSet`)
        .then(res => res.data.data);
}

export interface LoginUnifySetItem {
    loginUrl: string; //统一认证登录地址url
    rollBackUrl: string; //回调地址
    responseType: string; //认证模式（目前固定code）
    clientId: string; //应用标识
    clientSecret: string; //应用密码
    scope: string; //作用域
    state: string; //应用状态
    changePasswordUrl: string; //修改密码地址
}

/**
 * 教师端-获取统一身份认证参数
 */
export const getLoginUnifySet = () => {
    return axios
        .get<SuccessData<LoginUnifySetItem>>("/teacher/getLoginUnifySet")
        .then(res => res.data.data)
        .then(data => {
            const {
                loginUrl,
                responseType,
                clientId,
                rollBackUrl,
                scope,
                state
            } = data;

            const href = buildURL(
                `response_type=${responseType}`,
                `client_id=${clientId}`,
                `redirect_uri=${rollBackUrl}`,
                `scope=${scope}`,
                `state=${state}`
            );

            const ssoUrl = `${loginUrl}?${href}`;

            return { ...data, ssoUrl };
        });
};

/**
 * 判断参数拼接成url
 * @param args
 */
export function buildURL(...args: string[]) {
    // 使用 reduce 方法将参数过滤为有值的部分，并拼接成 URL
    return args.reduce((acc, curr) => {
        const curVal = curr.split("=").pop();
        if (curVal) {
            // 如果参数有值，则添加到 URL 中
            if (acc) {
                return `${acc}&${curr}`;
            } else {
                return curr;
            }
        } else {
            // 如果参数没有值，则跳过该参数
            return acc;
        }
    }, "");
}

/**
 * 教师端-修改密码
 * @param teacherNo
 * @param oldPassword 旧密码
 * @param newPassword 新密码
 */
export const updatePassword = (
    teacherNo: string,
    oldPassword: string,
    newPassword: string
) => {
    return MainRequest.post("/teacher/updatePassword", {
        teacherNo: teacherNo?.trim(),
        oldPassword: oldPassword?.trim(),
        newPassword: newPassword?.trim()
    });
};
